"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _defineProperty = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    text-transform: ", ";\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    text-transform: ", ";\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-family: ", ",\n      ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  text-align: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyBody2 = exports.typographyBody1 = exports.typographySubtitle2 = exports.typographySubtitle1 = exports.typographyTitle = exports.typographyLabelAction = exports.typographyLabelButton = exports.typographyLabelForm = exports.typographyTextSupportForm = exports.typographyTextSupport = exports.typographyTextParagraph = exports.typographyH6 = exports.typographyH5 = exports.typographyH4 = exports.typographyH3 = exports.typographyH2 = exports.typographyH1 = exports.typographyBase = void 0;

var _stylitas = require("@creditas/stylitas");

var typographyBase = function typographyBase(_ref) {
  var textAlign = _ref.textAlign;
  return (0, _stylitas.css)(_templateObject(), textAlign);
};

exports.typographyBase = typographyBase;

var typographyH1 = function typographyH1(_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return variant === 'h1' && (0, _stylitas.css)(_templateObject2(), theme.bHeadingh1Color, theme.bHeadingh1FontFamily, theme.bHeadingh1FallbackFontFamily, theme.bHeadingh1FontSize, theme.bHeadingh1FontWeight, theme.bHeadingh1LineHeight);
};

exports.typographyH1 = typographyH1;

var typographyH2 = function typographyH2(_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return variant === 'h2' && (0, _stylitas.css)(_templateObject3(), theme.bHeadingh2Color, theme.bHeadingh2FontFamily, theme.bHeadingh2FallbackFontFamily, theme.bHeadingh2FontSize, theme.bHeadingh2FontWeight, theme.bHeadingh2LineHeight);
};

exports.typographyH2 = typographyH2;

var typographyH3 = function typographyH3(_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant === 'h3' && (0, _stylitas.css)(_templateObject4(), theme.bHeadingh3Color, theme.bHeadingh3FontFamily, theme.bHeadingh3FallbackFontFamily, theme.bHeadingh3FontSize, theme.bHeadingh3FontWeight, theme.bHeadingh3LineHeight);
};

exports.typographyH3 = typographyH3;

var typographyH4 = function typographyH4(_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return variant === 'h4' && (0, _stylitas.css)(_templateObject5(), theme.bHeadingh4Color, theme.bHeadingh4FontFamily, theme.bHeadingh4FallbackFontFamily, theme.bHeadingh4FontSize, theme.bHeadingh4FontWeight, theme.bHeadingh4LineHeight);
};

exports.typographyH4 = typographyH4;

var typographyH5 = function typographyH5(_ref6) {
  var variant = _ref6.variant,
      theme = _ref6.theme;
  return variant === 'h5' && (0, _stylitas.css)(_templateObject6(), theme.bHeadingh5Color, theme.bHeadingh5FontFamily, theme.bHeadingh5FallbackFontFamily, theme.bHeadingh5FontSize, theme.bHeadingh5FontWeight, theme.bHeadingh5LineHeight);
};

exports.typographyH5 = typographyH5;

var typographyH6 = function typographyH6(_ref7) {
  var variant = _ref7.variant,
      theme = _ref7.theme;
  return variant === 'h6' && (0, _stylitas.css)(_templateObject7(), theme.bHeadingh6Color, theme.bHeadingh6FontFamily, theme.bHeadingh6FallbackFontFamily, theme.bHeadingh6FontSize, theme.bHeadingh6FontWeight, theme.bHeadingh6LineHeight);
};

exports.typographyH6 = typographyH6;

var typographyTextParagraph = function typographyTextParagraph(_ref8) {
  var variant = _ref8.variant,
      theme = _ref8.theme;
  return variant === 'paragraph' && (0, _stylitas.css)(_templateObject8(), theme.bTextparagraphColor, theme.bTextparagraphFontFamily, theme.bTextparagraphFallbackFontFamily, theme.bTextparagraphFontSize, theme.bTextparagraphFontWeight, theme.bTextparagraphLineHeight);
};

exports.typographyTextParagraph = typographyTextParagraph;

var typographyTextSupport = function typographyTextSupport(_ref9) {
  var variant = _ref9.variant,
      theme = _ref9.theme;
  return variant === 'support' && (0, _stylitas.css)(_templateObject9(), theme.bTextsupportColor, theme.bTextsupportFontFamily, theme.bTextsupportFallbackFontFamily, theme.bTextsupportFontSize, theme.bTextsupportFontWeight, theme.bTextsupportLineHeight);
};

exports.typographyTextSupport = typographyTextSupport;

var typographyTextSupportForm = function typographyTextSupportForm(_ref10) {
  var variant = _ref10.variant,
      theme = _ref10.theme;
  return variant === 'supportForm' && (0, _stylitas.css)(_templateObject10(), theme.bTextsupportformColor, theme.bTextsupportformFontFamily, theme.bTextsupportFallbackFontFamily, theme.bTextsupportformFontSize, theme.bTextsupportformFontWeight, theme.bTextsupportformLineHeight);
};

exports.typographyTextSupportForm = typographyTextSupportForm;

var typographyLabelForm = function typographyLabelForm(_ref11) {
  var variant = _ref11.variant,
      theme = _ref11.theme;
  return variant === 'form' && (0, _stylitas.css)(_templateObject11(), theme.bLabelformColor, theme.bLabelformFontFamily, theme.bLabelformFallbackFontFamily, theme.bLabelformFontSize, theme.bLabelformFontWeight, theme.bLabelformLineHeight);
};

exports.typographyLabelForm = typographyLabelForm;

var typographyLabelButton = function typographyLabelButton(_ref12) {
  var variant = _ref12.variant,
      theme = _ref12.theme;
  return variant === 'button' && (0, _stylitas.css)(_templateObject12(), theme.bLabelbuttonColor, theme.bLabelbuttonFontFamily, theme.bLabelbuttonFallbackFontFamily, theme.bLabelbuttonFontSize, theme.bLabelbuttonFontWeight, theme.bLabelbuttonLineHeight, theme.bLabelbuttonTextTransform);
};

exports.typographyLabelButton = typographyLabelButton;

var typographyLabelAction = function typographyLabelAction(_ref13) {
  var variant = _ref13.variant,
      theme = _ref13.theme;
  return variant === 'action' && (0, _stylitas.css)(_templateObject13(), theme.bLabelactionColor, theme.bLabelactionFontFamily, theme.bLabelactionFallbackFontFamily, theme.bLabelactionFontSize, theme.bLabelactionFontWeight, theme.bLabelactionLineHeight, theme.bLabelbuttonTextTransform);
};

exports.typographyLabelAction = typographyLabelAction;

var typographyTitle = function typographyTitle(_ref14) {
  var variant = _ref14.variant,
      props = _objectWithoutProperties(_ref14, ["variant"]);

  return variant === 'title' && (0, _stylitas.css)(_templateObject14(), typographyH2(_objectSpread({
    variant: 'h2'
  }, props)));
};

exports.typographyTitle = typographyTitle;

var typographySubtitle1 = function typographySubtitle1(_ref15) {
  var variant = _ref15.variant,
      props = _objectWithoutProperties(_ref15, ["variant"]);

  return variant === 'subtitle1' && (0, _stylitas.css)(_templateObject15(), typographyH4(_objectSpread({
    variant: 'h4'
  }, props)));
};

exports.typographySubtitle1 = typographySubtitle1;

var typographySubtitle2 = function typographySubtitle2(_ref16) {
  var variant = _ref16.variant,
      props = _objectWithoutProperties(_ref16, ["variant"]);

  return variant === 'subtitle2' && (0, _stylitas.css)(_templateObject16(), typographyH5(_objectSpread({
    variant: 'h5'
  }, props)));
};

exports.typographySubtitle2 = typographySubtitle2;

var typographyBody1 = function typographyBody1(_ref17) {
  var variant = _ref17.variant,
      props = _objectWithoutProperties(_ref17, ["variant"]);

  return variant === 'body1' && (0, _stylitas.css)(_templateObject17(), typographyTextParagraph(_objectSpread({
    variant: 'paragraph'
  }, props)));
};

exports.typographyBody1 = typographyBody1;

var typographyBody2 = function typographyBody2(_ref18) {
  var variant = _ref18.variant,
      props = _objectWithoutProperties(_ref18, ["variant"]);

  return variant === 'body2' && (0, _stylitas.css)(_templateObject18(), typographyTextSupport(_objectSpread({
    variant: 'support'
  }, props)));
};

exports.typographyBody2 = typographyBody2;